import type { ILanguageResources, ITranslationModule } from '../../../../../interfaces';
import { interpolate } from '../../../../../global';

// Dialog/Validation messages
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.data.v6.OutOfDateQuoteItemHandler.';
  public static readonly couldNotBeSaved = `${Id.prefix}couldNotBeSaved`;
  public static readonly version = `${Id.prefix}version`;
}

export class LangOutOfDateQuoteItemHandler {
  private constructor() {}
  public static couldNotBeSaved(): string {
    return interpolate(Id.couldNotBeSaved);
  }
  public static version(): string {
    return interpolate(Id.version);
  }
}

export class OutOfDateQuoteItemHandlerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.couldNotBeSaved, 'could not be saved', 'Error message when item could not be saved');
    register.add(Id.version, 'Version', 'Label for version column');
  }
}
